<template>
    <ul>
        <li><router-link to="/consultant/dashboard"> ACCUEIL</router-link></li>
        <li><router-link to="/consultant/rdvs">RENDEZ-VOUS</router-link></li>
            <li class="dropdown">
                <a class="">
                    <div class="text-center">
                        <p class="m-0"><small>DOSSIERS</small><i class="bi bi-chevron-down"></i></p>
                    </div>
                </a>
                <ul>
                    <li v-if="user.revendeur_id"><router-link to="/consultant/preseeds">PRESEED</router-link></li>
                    <li v-if="user.revendeur_id"><router-link to="/consultant/seeds">SEED</router-link></li>
                    <li v-if="user.cga_id"><router-link to="/consultant/series">SERIE A</router-link></li>
                    <li v-if="user.cga_id"><router-link to="/consultant/pmes">PME</router-link></li>
                </ul>
            </li>
            <li><router-link to="/consultant/deals">DEAL FLOW</router-link></li>
            <li><router-link to="/consultant/porteurs">PORTEURS DE PROJETS</router-link></li>
            <div style="display: inherit;" v-if="authenticated">
            <li class="dropdown">
                <a class="">
                    <div class="text-center">
                        <i style="font-size:25px;" class="bi bi-person"></i><i class="bi bi-chevron-down"></i>
                    </div>
                </a>
                <ul>
                    <li><router-link to="/profil">Profil</router-link></li>
                   
                    <li><a class="dropdown-item" href="javascript:void(0)" @click="logout">Se deconnecter</a></li>
                </ul>
            </li>
            </div>
    </ul>
</template>
<script>
    import {mapActions} from 'vuex';
    import axios from "axios";
    export default{
        name:'ConsultantNavbar',
        data: function(){
            return {
                authenticated:this.$store.state.auth.authenticated?this.$store.state.auth.authenticated:false,
                user : this.$store.state.auth.user,
            }
        },
        methods:{
            ...mapActions({
                signOut:"auth/signOut"
            }),
            async logout(){
                await axios.post(this.path+'auth/logout').then(()=>{
                    this.signOut()
                    this.authenticated = false;
                    window.location.href="/";
                })
                .catch(()=>window.location.href="/")
            }
        }
    }

</script>
<style scoped>
    .navbar a{
        text-decoration: none;
    }
</style>